import { Link } from '@tanstack/react-router';

interface AdminSubNavProps {
  active: 'overview' | 'events' | 'queues' | 'dependencies' | 'capacity' | 'costs';
}

const ITEMS: ReadonlyArray<{
  key: AdminSubNavProps['active'];
  to: string;
  label: string;
  testId: string;
}> = [
  { key: 'overview', to: '/admin/observability', label: 'Overview', testId: 'admin-nav-overview' },
  { key: 'queues', to: '/admin/observability/queues', label: 'Queues', testId: 'admin-nav-queues' },
  { key: 'dependencies', to: '/admin/observability/dependencies', label: 'Dependencies', testId: 'admin-nav-dependencies' },
  { key: 'capacity', to: '/admin/observability/capacity', label: 'Capacity', testId: 'admin-nav-capacity' },
  { key: 'costs', to: '/admin/observability/costs', label: 'Costs', testId: 'admin-nav-costs' },
  { key: 'events', to: '/admin/observability/events', label: 'Events', testId: 'admin-nav-events' },
];

export function AdminSubNav({ active }: AdminSubNavProps) {
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-2 text-sm">
      {ITEMS.map((item) => {
        const isActive = item.key === active;
        return (
          <Link
            key={item.key}
            to={item.to}
            data-testid={item.testId}
            className={
              isActive
                ? 'rounded-md bg-muted px-3 py-1 font-medium'
                : 'rounded-md px-3 py-1 text-muted-foreground hover:bg-muted/60 hover:text-foreground'
            }
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
